import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';

const plans = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserPlans: builder.query({
      query: () => `${apiRoutes.subscription}plans/`
    }),
    getFeatureAccess: builder.query<any, any>({
      query: (featureName) =>
        `${apiRoutes.subscription}feature/?feature_name=${featureName}`
    })
  })
});

export const { useLazyGetUserPlansQuery, useLazyGetFeatureAccessQuery } = plans;
